import { ROUTES } from '../../Lib/constants';
import YearList from './YearList';
import MakeList from './MakeList';
import MakeModelList from './MakeModelList';
import SimpleList from './SimpleList';

export default {
  [ROUTES.simpleList.name]: {
    screen: SimpleList,
    modal: true,
    modalProps: {
      width: 350,
      height: 300,
    },
  },

  [ROUTES.yearList.name]: {
    screen: YearList,
    modal: true,
    modalProps: {
      width: 450,
      height: 500,
    },
  },

  [ROUTES.makeList.name]: {
    screen: MakeList,
    modal: true,
    modalProps: {
      width: 450,
      height: 400,
    },
  },

  [ROUTES.makeModelList.name]: {
    screen: MakeModelList,
    modal: true,
    modalProps: {
      width: 450,
      height: 400,
    },
  },
};
